import { Container, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import BoldHeading from "../components/BoldHeading";
import Section from "../components/Section";
import WhiteGradientButton from "../components/WhiteGradientButton";
import why from "../images/NewUI/why.png";
import whyBg from "../images/NewUI/why_bg.png";

const WhySection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <>
      <Section
        pb="0"
        containerClass="d-flex flex-column"
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Box className="d-flex align-end flex-wrap" mb={md ? 5 : 3}>
          <BoldHeading pr={2} pb={!md ? 1 : 0} className={md ? "" : "col-12"}>
            WHY
          </BoldHeading>
          <Box pr={2}>
            <Typography variant="h5" lineHeight={1} mb="6px">
              NFT Gen2 is better
            </Typography>
            <Typography
              variant="h5"
              lineHeight={1}
              mb={1.7}
              fontWeight="normal"
            >
              than legacy NFT
            </Typography>
          </Box>
          <BoldHeading sx={{ fontWeight: "normal" }}>?</BoldHeading>
        </Box>

        <Typography whiteSpace="pre-line" mb={3}>
          {`The use of legacy NFT is very limited since the metadata is static and should not be manipulated.
            As a result, it is quite difficult for businesses to use NFT in any marketing activities.
            Also, managing legacy NFT campaigns is tough because there is no way to track the use of NFT properly.`}
        </Typography>
        <Typography mb={3}>
          NFT Gen 2 comes with the <strong>Dynamic Data Layer</strong> that is
          the layer available for businesses and brands to input the modifiable
          data and rules needed for implementing in any business activities.
        </Typography>
        <Typography mb={3}>
          With this ability, the business can use NFT Gen 2 in the way that the
          legacy NFT is incapable off.
        </Typography>

        <div style={{ opacity: "0", visibility: "hidden" }}>
          <img
            src={why}
            alt=""
            width={md ? "60%" : sm ? "80%" : "100%"}
            className="d-block mx-auto"
          />

          <WhiteGradientButton
            className="d-flex mx-auto align-center justify-center"
            sx={{ mt: 10 }}
            href="https://sixnetwork.gitbook.io/six-protocol/six-protocol/nft-gen-2"
            target="_blank"
          >
            LEARN MORE
          </WhiteGradientButton>
        </div>
      </Section>

      <Section
        disableContainer
        sx={{ mt: "-50%", mb: "-20%" }}
        className="p-relative"
        pb="0"
      >
        <img src={whyBg} alt="" className="d-block mx-auto" />

        <Container
          maxWidth={xl ? "xl" : "lg"}
          sx={{
            position: "absolute",
            top: "57%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <img
            src={why}
            alt=""
            width={md ? "60%" : sm ? "80%" : "100%"}
            className="d-block mx-auto"
          />

          <WhiteGradientButton
            className="d-flex mx-auto align-center justify-center"
            sx={{ mt: 10 }}
            href="https://sixnetwork.gitbook.io/six-protocol/six-protocol/nft-gen-2"
            target="_blank"
          >
            LEARN MORE
          </WhiteGradientButton>
        </Container>
      </Section>
    </>
  );
};

export default WhySection;
